import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('ui-navigation', {
  state: () => ({
    openedModal: null,
  }),

  actions: {
    setOpenedModal(val) {
      this.openedModal = val;
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
